export default __webpack_public_path__ + "static/media/emerald-mobileView.b64869e0.png";